import { twMerge } from 'tailwind-merge'
import { clsx, ClassValue } from 'clsx'

export const removeUndefined = <T extends object>(obj: T): Partial<T> => {
    return Object.fromEntries(
        Object.entries(obj).filter(([_, v]) => v !== undefined)
    ) as Partial<T>;
};

export function getAmountColor(amount: number) {
    return amount >= 0 ? "text-success" : "text-danger";
}

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(...inputs))
}

export function tw(...classes: string[]) {
    return twMerge(classes.join(" "))
}

